import React from 'react';
import { RulerFlex, Rect, PricePin } from './styles';
const Ruler = _ref => {
  let {
    rectColors,
    quartileIndex,
    adPrice,
    olxPrice
  } = _ref;
  const rectCount = rectColors.length;
  return React.createElement(RulerFlex, {
    justifyContent: "center"
  }, rectColors.map((fillColor, i) => {
    let radius;
    if (i === rectCount - 1) {
      radius = '0px 20px 20px 0px';
    } else if (i === 0) {
      radius = '20px 0px 0px 20px';
    }
    return React.createElement(Rect, {
      fillColor: fillColor,
      radius: radius,
      width: "calc(100%/".concat(rectCount, ")"),
      key: i,
      "data-testid": "meter-graph-bar-".concat(fillColor)
    }, quartileIndex === i && olxPrice && adPrice ? React.createElement(PricePin, {
      pinposition: "dynamic",
      quartile: quartileIndex,
      adPrice: adPrice,
      olxPrice: olxPrice,
      "data-testid": "meter-price-pin-dynamic"
    }) : null);
  }));
};
export default Ruler;